export default "__VITE_ASSET__926ff3f1__"